import { Center, Loader } from "@mantine/core";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "../auth/AuthContext";

/**
 * Gate for authenticated routes.
 *
 * Waits for the initial session check before deciding: redirecting while `loading` is
 * still true would bounce an already-signed-in user to /login on every hard refresh,
 * because the cookie session isn't confirmed until `GET /api/auth/me` returns.
 *
 * The intended destination is preserved in location state so the login form can send the
 * user where they were actually going.
 */
export default function RequireAuth() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Center h="60vh">
        <Loader aria-label="Checking your session" />
      </Center>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
